import type { FC } from 'react';
import { Button, Flex, Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import { CloseSmall } from '@shared/assets/icons/components';
import { Text } from '@shared/ui/antd';
import { METRIKA_EVENTS } from '@modules/presets/lib/constants';
import styles from './metrika-guide-modal.module.scss';

interface MetrikaGuideModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const MetrikaGuideModal: FC<MetrikaGuideModalProps> = ({ isOpen, onClose }) => {
  const { t } = useTranslation('translation', { keyPrefix: 'presets.editor.metrikaGuide' });

  return (
    <Modal
      centered
      open={isOpen}
      width={720}
      footer={null}
      title={null}
      closeIcon={<CloseSmall />}
      destroyOnClose
      onCancel={onClose}
    >
      <Flex vertical gap={24} className={styles.root}>
        <Text variant="2xl" fontWeight={600}>
          {t('title')}
        </Text>

        <section>
          <Text variant="lg" fontWeight={600}>
            {t('counter.title')}
          </Text>
          <ul>
            <li>{t('counter.open')}</li>
            <li>{t('counter.copy')}</li>
            <li>{t('counter.paste')}</li>
          </ul>
        </section>

        <section>
          <Text variant="lg" fontWeight={600}>
            {t('goals.title')}
          </Text>
          <ol>
            <li>{t('goals.open')}</li>
            <li>{t('goals.add')}</li>
            <li>{t('goals.type')}</li>
            <li>{t('goals.save')}</li>
          </ol>
          <div className={styles.events}>
            {METRIKA_EVENTS.map((event) => (
              <div key={event} className={styles.eventRow}>
                <code>{event}</code>
                <span>{t(`events.${event}`)}</span>
              </div>
            ))}
          </div>
        </section>

        <section>
          <Text variant="lg" fontWeight={600}>
            {t('connect.title')}
          </Text>
          <p>{t('connect.description')}</p>
          <p>{t('connect.done')}</p>
        </section>

        <Button size="large" type="primary" block onClick={onClose}>
          {t('close')}
        </Button>
      </Flex>
    </Modal>
  );
};
